import React, { useMemo, useState } from 'react';
import {
	ToothEndodontic,
	ToothEndodonticPain,
	ToothEndodonticTest,
} from '../../../../graphql/graphql';
import { Dispatch, SetStateAction } from 'react';
import { ToggleButtonView } from '../../../../Enums/ToggleButtonView.enum';
import ToggleButtons from '../../../../Components/ToggleButtons/ToggleButtons';
import {
	ENDODONTIC_BUTTON_OPTIONS,
	EndodonticButtonOption,
} from '../../Helpers/endodontic/endodonticButtonOptions';
import DENTModalOverviewGeneralEndodonticElectricityButtons from '../DENTModalOverviewGeneralEndodontic/DENTModalOverviewGeneralEndodonticElectricityButtons';
import DENTModalOverviewGeneralEndodonticPainButtons from '../DENTModalOverviewGeneralEndodontic/DENTModalOverviewGeneralEndodonticPainButtons';
import DENTModalOverviewGeneralEndodonticTemperatureButtons from '../DENTModalOverviewGeneralEndodontic/DENTModalOverviewGeneralEndodonticTemperatureButtons';

interface Props {
	values: ToothEndodontic;
	setValues: Dispatch<SetStateAction<ToothEndodontic>>;
}

const DENTToothQuickEndodonticModalButtons = ({ values, setValues }: Props) => {
	const [selectedOption, setSelectedOption] = useState(
		ENDODONTIC_BUTTON_OPTIONS[0],
	);

	const selectedComponent = useMemo(() => {
		const type = selectedOption.value;

		switch (type) {
			case 'cold':
			case 'heat':
				return (
					<DENTModalOverviewGeneralEndodonticTemperatureButtons
						values={values[type]}
						onChange={(value: ToothEndodonticTest | undefined) =>
							handleOnChange(type, value)
						}
					/>
				);
			case 'electric':
				return (
					<DENTModalOverviewGeneralEndodonticElectricityButtons
						value={values.electric}
						onChange={(value: number) => handleOnChange('electric', value)}
					/>
				);
			case 'percussion':
			case 'palpation':
				return (
					<DENTModalOverviewGeneralEndodonticPainButtons
						value={values[type]}
						onChange={(value: ToothEndodonticPain) =>
							handleOnChange(type, value)
						}
					/>
				);
			default:
				return <div></div>;
		}
	}, [selectedOption.value, values]);

	const handleOnChange = <T extends EndodonticButtonOption['value']>(
		key: T,
		value: ToothEndodontic[T],
	) => {
		setValues(prev => ({
			...prev,
			[key]: value,
		}));
	};

	return (
		<div>
			<ToggleButtons<EndodonticButtonOption>
				options={ENDODONTIC_BUTTON_OPTIONS}
				selectedOption={selectedOption}
				onChange={setSelectedOption}
				view={ToggleButtonView.HORIZONTAL_MULTILINE}
			/>
			{selectedComponent}
		</div>
	);
};

export default DENTToothQuickEndodonticModalButtons;
